// @flow
import queryString from 'query-string';
import * as React from 'react';
import { withRouter } from 'react-router';
import type { Location, RouterHistory } from 'react-router';
import { trackPageView } from 'utils/analytics';
import allowRedirect from 'utils/allowRedirect';
import isPathOnlyUrl from 'utils/isPathOnlyUrl';
import type { CurrentUser } from 'api/currentUser';
import LoginPage from 'pages/LoginPage';
import { setDocumentTitle } from '../utils/meta';

type Props = {
  location: Location,
  history: RouterHistory
};

class LoginPageContainer extends React.PureComponent<Props> {
  queryParams = queryString.parse(this.props.location.search);

  get savedListing() {
    return this.props.location.state && this.props.location.state.savedListing;
  }

  get subscribedSubsite() {
    return (
      this.props.location.state && this.props.location.state.subscribedSubsite
    );
  }

  get title() {
    return this.props.location.state && this.props.location.state.title;
  }

  get inviteId() {
    return (
      this.queryParams.invite ||
      (this.props.location.state && this.props.location.state.inviteId)
    );
  }

  get email() {
    return this.props.location.state && this.props.location.state.email;
  }

  get redirectTo() {
    return (
      this.queryParams.to ||
      (this.props.location.state && this.props.location.state.redirectTo)
    );
  }

  componentDidMount() {
    trackPageView('Login', {
      page_type: 'Login'
    });
    setDocumentTitle(getText('Log In'));
  }

  redirect = (user: CurrentUser) => {
    let redirectTo = null;

    if (this.inviteId) {
      redirectTo = `/user-invites/${this.inviteId}`;
    } else {
      redirectTo = this.redirectTo;
    }
    if (!redirectTo || !allowRedirect(redirectTo)) {
      redirectTo = `/${user.locale}/`;
    }
    if (user.locale !== USER_LOCALE) {
      const regexp = new RegExp(`^/${USER_LOCALE}`);
      redirectTo = redirectTo.replace(regexp, `/${user.locale}`);
      window.location = redirectTo;
    }
    if (!isPathOnlyUrl(redirectTo)) {
      window.location = redirectTo;
      return;
    }

    // TODO: route relative urls with react-router once all pages have been redesigned
    window.location = redirectTo;
    // this.props.history.push(redirectTo);
  };

  render() {
    return (
      <LoginPage
        onLogin={this.redirect}
        redirectTo={this.redirectTo}
        email={this.email}
        inviteId={this.inviteId}
        savedListing={this.savedListing}
        subscribedSubsite={this.subscribedSubsite}
        title={this.title}
      />
    );
  }
}

export default withRouter(LoginPageContainer);
